<template>
  <b-card
    class='mt-3'
  >
    <b-modal
      v-if='removeFlatPagePromptModal'
      v-model='removeFlatPagePromptModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => actions.handleRemoveFlatPage(flatPage.id)'
      centered
    >
      Czy usunąć podstronę <i v-if='flatPage.title.pl'>{{flatPage.title.pl.toUpperCase()}}</i> ?
    </b-modal>

    <b-modal
      v-if='removeFlatPageItemPromptModal'
      v-model='removeFlatPageItemPromptModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => actions.handleRemoveFlatPageItem(flatPage.id, itemToRemove.id)'
      centered
    >
      Czy usunąć element podstrony <i v-if='itemToRemove && itemToRemove.type'>{{itemToRemove.type.toUpperCase()}}</i> ?
    </b-modal>

    <b-row>
      <b-col>
        <b-button variant="danger" size='sm' @click='() => removeFlatPagePromptModal = true'>
          <b-icon-trash />
        </b-button>
        <div v-if='flatPage.title && flatPage.title.pl' class='font-weight-bold mt-3'>
          <b-form-checkbox
            v-model='modelActive'
            @input='(e) => actions.handleFlatPagePropChanged(flatPage.id, "active", e)'
            class='float-left mt-2'
          >
            <h4>{{flatPage.title.pl.toUpperCase()}}</h4>
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col>
        <b-button-group class='float-right' size='sm'>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "text")'>Treść</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "youtube")'>Youtube</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "youtubePlugin")'>Youtube plugin</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "image")'>Obraz</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "imageList")'>Lista obrazów</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "banner")'>Banner</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "map")'>Mapa</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "webview")'>Webview</b-button>
          <b-button @click='() => actions.handleAddFlatPageItem(flatPage.id, "faq")'>FAQ</b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col class='mt-3' cols='7'>
        <flat-page-title :flatPage='flatPage' />
      </b-col>    

      <b-col class='mt-3' cols='3'>
        <label>Pozycja</label>
        <b-form-select
          v-model='defaultPosition'
          class='form-control'
          :options="positions"
          @input='(e) => actions.handleFlatPagePropChanged(flatPage.id, "position", e)'
        />
      </b-col> 
      
      <b-col class='mt-3' cols="2">
        <label>Tło główne</label><br/>
        <b-form-checkbox
          v-model='mainBackground'
          @input='(e) => actions.handleFlatPagePropChanged(flatPage.id, "mainBackground", e)'
          class='float-left'
        />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-list-group>
          <b-list-group-item
            class='mb-3'
            style='border-width: 3px; border-radius: 0.375rem;'
            v-for='(item, i) in flatPage.items'
            :key='i'
          > 
            
            <div class='float-right'>
              <b-button-group size='sm'>
                <b-button variant="danger" @click='() => { itemToRemove = item; removeFlatPageItemPromptModal = true; }'><b-icon-trash /></b-button>
                <b-button variant="info" @click='() => actions.handleClickMoveUpFlatPageItem(flatPage.id, item.id)'><b-icon-caret-up-fill /></b-button>
                <b-button variant="success" @click='() => actions.handleClickMoveDownFlatPageItem(flatPage.id, item.id)'><b-icon-caret-down-fill /></b-button>
              </b-button-group>
            </div>
            
            <div v-if='item.type === "youtube"'>
              <flat-page-youtube
                :flatPage='flatPage'
                :item='item'
              />
            </div>

            <div v-if='item.type === "youtubePlugin"'>
              <flat-page-youtube-plugin
                :flatPage='flatPage'
                :item='item'
              />
            </div>

            <div v-if='item.type === "text"'>
              <flat-page-text
                :flatPage='flatPage'
                :item='item'
              />
            </div>

            <div v-if='item.type === "image"'>
              <flat-page-image
                :flatPage='flatPage'
                :item='item'
              />
            </div>

            <div v-if='item.type === "map"'>
              <flat-page-map
                :flatPage='flatPage'
                :item='item'
              />
            </div>

            <div v-if='item.type === "webview"'>
              <flat-page-webview
                :flatPage='flatPage'
                :item='item'
              />
            </div>            

            <div v-if='item.type === "banner"'>
              <flat-page-banner
                :flatPage='flatPage'
                :item='item'
              />
            </div>

            
            <div v-if='item.type === "imageList"'>
              <flat-page-image-list
                :flatPage='flatPage'
                :item='item'
              />
            </div>

            <div v-if='item.type === "faq"'>
              <flat-page-faq
                :flatPage='flatPage'
                :item='item'
              />
            </div>
            
          </b-list-group-item>  
        </b-list-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

  import { LOCALES } from '@/utils';
  import {
    handleAddFlatPageItem,
    handleRemoveFlatPage,
    handleFlatPagePropChanged,
    handleRemoveFlatPageItem,
    handleClickMoveUpFlatPageItem,
    handleClickMoveDownFlatPageItem
  } from '@/store/utils.js'
  import Title from './Title'
  import Text from './Text'
  import Image from './Image'
  import Youtube from './Youtube'
  import YoutubePlugin from './YoutubePlugin'
  import Webview from './Webview'
  import Map from './Map'
  import Banner from './Banner'
  import ImageList from './ImageList'
  import Faq from './Faq'
  import {
    BIconCaretUpFill,
    BIconCaretDownFill,
    BIconTrash,
  } from 'bootstrap-vue'

  export default {
    components: {
      'flat-page-title': Title,
      'flat-page-text': Text,
      'flat-page-image': Image,
      'flat-page-youtube': Youtube,
      'flat-page-youtube-plugin': YoutubePlugin,
      'flat-page-map': Map,
      'flat-page-webview': Webview,
      'flat-page-banner': Banner,
      'flat-page-image-list': ImageList,
      'flat-page-faq': Faq,
      BIconCaretUpFill,
      BIconCaretDownFill,
      BIconTrash,
    },
    props: ['flatPage'],
    data() {
      return {
        actions: {
          handleAddFlatPageItem,
          handleRemoveFlatPage,
          handleFlatPagePropChanged,
          handleRemoveFlatPageItem,
          handleClickMoveUpFlatPageItem,
          handleClickMoveDownFlatPageItem,
        },
        removeFlatPagePromptModal: false,
        removeFlatPageItemPromptModal: false,
        itemToRemove: null,
        locales: LOCALES,
        modelActive: this.flatPage.active ? this.flatPage.active : false,
        defaultPosition: this.flatPage.position || 'FLAT_PAGE',
        mainBackground: this.flatPage.mainBackground || false,
        positions: [
          { value: 'FLAT_PAGE', text: 'FLAT PAGE' },
          { value: 'NEWS_PAGE_1', text: 'NEWS PAGE AFTER BUY TICKET' },
        ]
      }
    },
  }

</script>